<template>
  <div class="profile-component-readonly">
    <section>
      <div class="profile-component-readonly-profil-edit">
        <IconLabel heavy :label="$t('ETAB.PAGES.PROFIL.@GENERAL_INFORMATION')" icon="icon-f-home" no-padding />
        <QBtn icon="edit" color="secondary" round @click.prevent="$emit('passProfileToWriteMode')" />
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_NAME") }}</label>
        <p>{{ profile[IEtabProfile.etabName] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_ADDRESS") }}</label>
        <p>{{ profile[IEtabProfile.address] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_POSTAL_CODE") }}</label>
        <p>{{ profile[IEtabProfile.postalCode] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_CITY") }}</label>
        <p>{{ profile[IEtabProfile.city] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@COUVERT_NUMBER") }}</label>
        <p>{{ profile[IEtabProfile.seats] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@DESCRIPTION") }}</label>
        <p>{{ profile[IEtabProfile.description] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@WEB_SITE") }}</label>
        <p>{{ profile[IEtabProfile.website] }}</p>
      </div>

      <div>
        <label>{{ $t("ETAB.FORMS.LABELS.@FACEBOOK_PAGE") }}</label>
        <p>{{ profile[IEtabProfile.facebook] }}</p>
      </div>
    </section>
  </div>
</template>
<script>
  import { EtabProfileModel, AccountModel, IEtabProfile, IAccount } from "@core/models";

  export default {
    props: {
      profile: { type: Object, default: () => new EtabProfileModel() },
      account: { type: Object, default: () => new AccountModel() },
    },
    emits: ["passProfileToWriteMode"],
    created() {
      this.IEtabProfile = IEtabProfile;
      this.IAccount = IAccount;
    },
  };
</script>

<style lang="scss">
  .profile-component-readonly {
    .profile-component-readonly-profil-edit {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    > section {
      padding: 15px 0 0;
      label {
        display: block;
        margin-top: 15px;
        font-weight: bold;
      }
    }
  }
</style>
